import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import MainLayout from '@src/layouts/MainLayout.tsx'

import ErrorMotionSensor from '@src/pages/error/errorMotionSensor.tsx'
import ErrorCameraSensor from '@src/pages/error/errorCameraSensor.tsx'
import ErrorGpsSensor from '@src/pages/error/errorGpsSensor.tsx'
import CampaignEndPage from '@src/pages/campaignEnd.tsx'

const HomePage = lazy(() => import('@src/pages/home.tsx'))
const MapPage = lazy(() => import('@src/pages/map.tsx'))
const ExperiencePage = lazy(() => import('@src/pages/experience.tsx'))
const DownloadPage = lazy(() => import('@src/pages/download.tsx'))
const SplashPage = lazy(() => import('@src/pages/splash.tsx'))
const IntroPage = lazy(() => import('@src/pages/intro.tsx'))
const PracticePage = lazy(() => import('@src/pages/practice.tsx'))
const CheonggyeStoryPage = lazy(() => import('@src/pages/story.tsx'))
const GuidePermission = lazy(() => import('@src/pages/guidePermission.tsx'))
const GuideService = lazy(() => import('@src/pages/guideService.tsx'))
const CampaignPage = lazy(() => import('@src/pages/campaign.tsx'))

export default function App() {
  return (
    <Routes>
      {/** 메인 페이지 관련 **/}
      <Route index element={<SplashPage />} />

      <Route element={<MainLayout />}>
        <Route path='/intro' element={<IntroPage />} />
        <Route path='/home' element={<HomePage />} />
        <Route path='/guide/service' element={<GuideService />} />
        <Route path='/guide/permission' element={<GuidePermission />} />
        <Route path='/experience' element={<ExperiencePage />} />
        <Route path='/practice' element={<PracticePage />} />
        <Route path='/story' element={<CheonggyeStoryPage />} />
        <Route path='/map' element={<MapPage />} />
        <Route path='/campaign' element={<CampaignPage />} />
        <Route path='/campaign/end' element={<CampaignEndPage />} />
        <Route path='/pledge/download' element={<DownloadPage />} />

        {/** 개발 내용에서 제외된 페이지 **/}
        {/*<Route path='/map/collection/download' element={<DownloadPage />} />*/}
        {/*<Route path='/map/collection' element={<CollectionPage />} />*/}
        {/*<Route path='/pledge' element={<PledgePage />} />*/}
        <Route path={'*'} element={<Navigate replace to={'/home'} />} />
      </Route>

      {/** 에러 페이지 관련 **/}
      <Route
        path={'/error/*'}
        element={
          <Routes>
            <Route path={'motion-sensor'} element={<ErrorMotionSensor />} />
            <Route path={'camera-sensor'} element={<ErrorCameraSensor />} />
            <Route path={'gps-sensor'} element={<ErrorGpsSensor />} />
            <Route path={'*'} element={<Navigate replace to={'/home'} />} />
          </Routes>
        }
      />
      <Route path={'*'} element={<Navigate replace to={'/home'} />} />
    </Routes>
  )
}
